import { Ellipsis } from 'lucide-react';
import { buildCoreMiscNavItems } from '@/components/layout/NavBar/nav-items';
import { useActiveOrgSlug } from '@/lib/useOrgRoutes';
import { ResourceGroupOverviewPage } from './ResourceGroupOverviewPage';

export function MiscOverviewPage() {
  const slug = useActiveOrgSlug();
  return (
    <ResourceGroupOverviewPage
      icon={<Ellipsis className="h-5 w-5" />}
      title="Misc"
      description="Extra tools and fun stuff."
      coreNavItems={buildCoreMiscNavItems(slug)}
      group="misc"
    />
  );
}
